import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription, interval } from 'rxjs';
import { throttle } from 'rxjs';
import { UserSessionService } from './user-session.service';
import { ModalService } from './modal.service';
import { EOI_IDLE_TIMEOUT_CONFIG } from "../global-constants";

@Injectable({
  providedIn: 'root'
})
export class AmuTimerService {
  private idleSubject: Subject<string> = new Subject<string>();
  private config: any = EOI_IDLE_TIMEOUT_CONFIG;
  private idleSeconds: number = this.config.idleSeconds;
  private warningSeconds: number = this.config.warningSeconds;
  private lastActivityTime?: Date;
  private idleCheckInterval?: number = 10; // in seconds
  private idleSubscription?: Subscription;

  constructor(
      private userSessionService: UserSessionService,
      private modalService: ModalService
    ) {
      this.resetTimer();
      this.startWatching();
  }

  public startWatching(): void {
    this.idleSubscription = interval(this.idleCheckInterval * 1000)
    .pipe(throttle(() => interval(1000))).subscribe(() => {
      const now = new Date();

      let idleTime = (now.getTime() - this.lastActivityTime!.getTime())/1000;

      if(idleTime > ((this.idleSeconds - this.warningSeconds))) {
        if(idleTime > (this.idleSeconds)){
          this.userSessionService.data.sessionTimedOut = true;
          this.idleSubject.next("timeOut");
        } else {
          this.idleSubject.next("showWarning");
        }
      } 
    });
  }

  get getIdleStatus(): Observable<string> {
    return this.idleSubject.asObservable();
  }

  public resetTimer(): void {
    this.lastActivityTime = new Date();
    this.idleSubject.next("resetTimer");
  }

  public stopWatching(): void {
    if(this.idleSubscription) {
      this.idleSubscription.unsubscribe();
    }
  }

  //start the timer
  private startTheTimer = new BehaviorSubject(false);
  public isTimerStarted = this.startTheTimer.asObservable();

  startOrStopTimer(message: boolean) {
    //true starts the timer, false stops the timer
    this.startTheTimer.next(message);
  }

  showTimeoutWarning(): void {
    this.modalService.showModal('prism-ui-modal-timer-modal');
  }

}